import { render, staticRenderFns } from "./UiRadio.vue?vue&type=template&id=576a2518"
import script from "./UiRadio.vue?vue&type=script&lang=js"
export * from "./UiRadio.vue?vue&type=script&lang=js"
import style0 from "./UiRadio.vue?vue&type=style&index=0&id=576a2518&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports